export const auto_read_notification = `subscription auto_read_notification{
    auto_read_notification
}`;
